<template>
  <content>
    <span v-if="showSpan">
      {{
        departs && departs.length > 0
          ? [...departs]
              .map(r => {
                return $getDepartTree(r).departName
              })
              .join(',')
          : ''
      }}
    </span>
    <a-tree-select
      v-else
      class="select-depart-tree"
      v-model="departs"
      treeDefaultExpandAll
      :allowClear="allowClear"
      :disabled="disabled"
      :placeholder="placeholder"
      :treeCheckable="treeCheckable"
      :treeCheckStrictly="treeCheckStrictly"
      :treeData="treeData"
      :showSearch="showSearch"
    ></a-tree-select>
  </content>
</template>

<script>
export default {
  name: 'JSelectDepartTree',
  props: {
    // 外部传进来的v-model
    value: {
      type: Object,
      default: null
    },
    // 显示清除按钮
    allowClear: {
      type: Boolean,
      default: true
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 显示为span
    showSpan: {
      type: Boolean,
      default: false
    },
    // 选择框默认文字
    placeholder: {
      type: String,
      default: '请选择组织'
    },
    // 显示checkbox,自动变为多选
    treeCheckable: {
      type: Boolean,
      default: false
    },
    // checkable 状态下节点选择完全受控（父子节点选中状态不再关联）
    treeCheckStrictly: {
      type: Boolean,
      default: true
    },
    // treeNodes 数据
    treeData: {
      type: Array,
      default: []
    },
    // 在下拉中显示搜索框(仅在单选模式下生效)
    showSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      departs: []
    }
  },
  created() {
    if (this.treeData.length == 0) {
      this.treeData = this.$getDepartTree()
    }
  },
  mounted() {},
  computed: {},
  watch: {
    value: {
      handler(newVal, oldVal) {
        this.departs = newVal
      },
      immediate: true,
      deep: true
    },
    departs: {
      handler(newVal, oldVal) {
        this.$emit('input', newVal)
        this.$emit('change', newVal)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.select-depart-tree {
  /deep/ .ant-select-selection--multiple {
    max-height: 32px;
    overflow-y: auto;
  }

  /deep/ .ant-select-selection--multiple::before {
    content: ' ';
    display: block;
    position: absolute;
    top: 9px;
    right: 11px;
    width: 8px;
    height: 8px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
    border-left: 1px solid rgba(0, 0, 0, 0.25);
    transform: rotate(-45deg) skew(-8deg, -8deg);
    transition: all 0.3s;
    clear: both;
  }

  /deep/ .ant-select-open .ant-select-selection--multiple::before {
    transform: rotate(135deg) skew(-8deg, -8deg);
    top: 14px;
  }
}
</style>
